<!-- download app div -->
    <div class="app-download-div" *ngIf="isLogin() && env.host.downloadApk != '' && downloadDivStatus">
        <img src="https://cdn-icons-png.flaticon.com/512/300/300218.png">
        <h5>download our app <span>instant download on your deivce</span></h5>
        <a [href]="env.host.downloadApk" target="_blank">install</a>
        <i class="mdi mdi-window-close" (click)="hideDwnApk()"></i>
    </div>
    <!-- download app div end -->
<!-- Topbar Start -->
<div class="navbar-custom">
  <div class="container-fluid">
      
      <!-- ONLY IF LOGIN -->
      <ul class="list-unstyled float-right mb-0 acba_div" *ngIf="isLogin()">
        
        <!-- ========== New Right Sidebar Start ========== -->
          <li class="notification-list nav-profile">
            <a href="javascript:void(0);" class="nav-link nav-user mr-0 waves-effect waves-light" (click)="openRightBar();">
                <span class="line coin cmenu">
                    <img alt="" src="https://speedcdn.io/assets/radheexch-client/icons/coin.svg" class="pr-1 cmenu">
                </span>
                <span>{{fixedPostDecimal(user?.available_balance)}}</span>
            </a>
          </li>
        <!-- New Right Sidebar End -->

          <!-- ========== Old Right Sidebar Start ========== -->
            <!-- <li class="dropdown notification-list topbar-dropdown nav-profile">
                <a class="nav-link dropdown-toggle nav-user mr-0 waves-effect waves-light"
                    data-toggle="dropdown" href="#" role="button" aria-haspopup="false" aria-expanded="false">
                    <span>
                        <i class="mdi mdi-account"></i> my account <i class="mdi mdi-menu-down"></i>
                    </span>
                </a>
                <div class="dropdown-menu dropdown-menu-right header-dropdown-menu">
                    <div class="dropdown-header">
                        <h4>{{user.username}} <span class="gmt" title="Time Zone">{{todayDate | date:'zzzz'}}</span></h4>
                    </div>
                    <a href="javascript:void();" routerLink="/change-password" class="dropdown-item notify-item">
                        <img class="img-fluid" src="assets/img/change-password.svg">
                        change password
                    </a>
                    <a href="javascript:void();" routerLink="/reports/account-statement" class="dropdown-item notify-item">
                        <img class="img-fluid" src="assets/img/account-statement.svg">
                        account statement
                    </a>
                    <a href="javascript:void();" routerLink="/reports/profit-loss" class="dropdown-item notify-item">
                        <img class="img-fluid" src="assets/img/profit-loss-report.svg">
                        profit loss report
                    </a>
                    <a href="javascript:void();" routerLink="/reports/unsettled-bets" class="dropdown-item notify-item">
                        <img class="img-fluid" src="assets/img/unsettle-bet.svg">
                        unsettled bet
                    </a>
                    <a href="javascript:void();" routerLink="/stake-setting" class="dropdown-item notify-item">
                        <img class="img-fluid" src="assets/img/set-button-value.svg">
                        set button value
                    </a>
                    <a href="javascript:void();" routerLink="/market-analysis" class="dropdown-item notify-item">
                      <img class="img-fluid" src="assets/img/bet-history.svg">
                      market analysis
                    </a>
                    <a href="javascript:void();" routerLink="/rules" class="dropdown-item notify-item">
                        <img class="img-fluid" src="assets/img/rules.svg">
                        rules
                    </a>
                    <a href="javascript:void();" (click)="logOut()" class="dropdown-item notify-item logout">
                        logout
                        <img class="img-fluid" src="assets/img/log-out.svg">
                    </a>
                </div>
            </li> -->
          <!-- Old Right Sidebar End -->

          <!-- <li class="dropdown notification-list topbar-dropdown nav-profile">
              <a class="nav-link dropdown-toggle nav-user mr-0 waves-effect waves-light">
                data-toggle="dropdown" href="#" role="button" aria-haspopup="false" aria-expanded="false"
                  <span class="line coin cmenu">
                      <img alt="" src="https://images.staticcontent.io/casino/banner/images/coin.svg"
                          class="pr-1 cmenu">
                  </span>
                  <span>{{fixedPostDecimal(user?.available_balance)}}</span>
                  <i class="mdi mdi-menu-down"></i>
              </a>
              <div class="dropdown-menu dropdown-menu-right wallet-detail">
                  <div class="wallet-detail-group cmenu">
                      <dl class="wallet-detail-content" routerLink="/market-analysis">
                          <dt>Exposure</dt>
                          <dd class="wallet-balance-num">
                              <span [ngClass]="user?.expose >= 0 ? 'profit' : 'loss'">{{positiveVal(fixedPostDecimal(user?.expose))}}</span>
                          </dd>
                      </dl>
                  </div>
                  <div class="wallet-detail-group cmenu">
                      <dl class="wallet-detail-content">
                          <dt>P & L</dt>
                          <dd class="wallet-balance-num cmenu">
                              <span [ngClass]="user.pl >= 0 ? 'profit' : 'loss'">{{user?.pl}}</span>
                          </dd>
                      </dl>
                  </div>
                  <div class="btn-box cmenu"><button class="btn">Close</button></div>
              </div>
          </li> -->

          <li class="notification-list nav-profile">
            <a class="nav-link nav-user mr-0 waves-effect waves-light">
                <span routerLink="/market-analysis">
                    Exp: <span>{{positiveVal(fixedPostDecimal(user?.expose))}}</span>
                    <!-- <span [ngClass]="user?.expose >= 0 ? 'profit' : 'loss'"> -->
                </span>
            </a>
          </li>

          <!-- <li class="dropdown notification-list topbar-dropdown nav-profile">
              <a class="nav-link dropdown-toggle nav-user mr-0 waves-effect waves-light"
                  data-toggle="dropdown" href="#" role="button" aria-haspopup="false" aria-expanded="false">
                  <span class="line coin cmenu cgtext">RC</span>
                  <span>0.00</span>
                  <i class="mdi mdi-menu-down"></i>
              </a>
              <div class="dropdown-menu dropdown-menu-right wallet-detail">
                  <div class="wallet-detail-group cmenu">
                      <dl class="wallet-detail-content">
                          <dt data-toggle="modal" data-target="#ExposurePopup">Exposure</dt>
                          <dd class="wallet-balance-num">
                              <span>0.00</span>
                          </dd>
                      </dl>
                  </div>
                  <div class="wallet-detail-group cmenu">
                      <dl class="wallet-detail-content">
                          <dt>P & L</dt>
                          <dd class="wallet-balance-num cmenu">
                              <span>0.00</span>
                          </dd>
                      </dl>
                  </div>
                  <div class="btn-box cmenu"><button class="btn">Close</button></div>
              </div>
          </li> -->
      </ul>

      <!-- IF NO LOGIN -->
      <ul class="list-unstyled float-right mb-0 acba_div" *ngIf="!isLogin()">
        <li class="">
          <a href="javascript:void(0)" class="mr-0 waves-effect waves-light" (click)="openLogin('')">
              <span>
                  <i class="mdi mdi-account"></i> Log In
              </span>
          </a>
        </li>
        <li class="" *ngIf="env.host.signUpActive">
            <a href="javascript:void(0)" class="mr-0 waves-effect waves-light" (click)="openSignUpModal('')">
                <span>
                    <i class="mdi mdi-account"></i> SignUp
                </span>
            </a>
          </li>  
      </ul> 

      <ul class="list-unstyled topnav-menu topnav-menu-left m-0">
          <li>
              <button class="button-menu-mobile waves-effect waves-light button-menu-mobile">
                  <i class="mdi mdi-menu"></i>
              </button>
          </li>
      </ul>

      <!-- <div class="sidebar-mobile">
        <ul>
            <li>test 1</li>
            <li>test 1</li>
            <li>test 1</li>
            <li>test 1</li>
            <li>test 1</li>
            <li>test 1</li>
        </ul>
      </div> -->

      <!-- LOGO -->
      <div class="logo-box">
          <a href="javascript:void();" [routerLink]="isLogin() ? ['/dashboard'] : ['/home']" routerLink="/home" class="logo logo-light text-center">
              <span class="logo-sm">
                  <img src="assets/img/{{env.host.name}}/logo.png" alt="">
              </span>
              <span class="logo-lg">
                  <img src="assets/img/{{env.host.name}}/logo.png" alt="">
              </span>
          </a>
      </div>

      <div class="clearfix"></div>
  </div>

  <div class="marquee_news">
    <span class="up_icon"><i class="mdi mdi-bullhorn"></i></span>
    <marquee>{{message}}</marquee>
  </div>

    <div class="btns__deposit_withdrawal d-none-desktop" *ngIf="depoWithdrawCondition()">
        <div class="deposit dw">
            <a href="javascript:void(0);" [routerLink]="['/deposit']">
                <img class="img-fluid" src="https://speedcdn.io/assets/radheexch-client/icons/deposit-icon.png">
                <span>&nbsp;Deposit</span>
            </a>
        </div>
        <div class="withdraw dw">
            <a href="javascript:void(0);" [routerLink]="['/withdraw']">
                <img class="img-fluid" src="https://speedcdn.io/assets/radheexch-client/icons/withdrawal-icon.png">
                <span>&nbsp;Withdraw</span>
            </a>
        </div>
    </div>
    <div class="btns__deposit_withdrawal d-none-desktop" *ngIf="demoLoginDepoWithdrawCondition()">
        <div class="deposit dw">
            <a href="javascript:void(0);" [href]="env.demoDWLink">
                <img class="img-fluid" src="https://speedcdn.io/assets/radheexch-client/icons/deposit-icon.png">
                <span>&nbsp;Deposit</span>
            </a>
        </div>
        <div class="withdraw dw">
            <a href="javascript:void(0);" [href]="env.demoDWLink">
                <img class="img-fluid" src="https://speedcdn.io/assets/radheexch-client/icons/withdrawal-icon.png">
                <span>&nbsp;Withdraw</span>
            </a>
        </div>
    </div>


  <div class="sportsMenus">
      <ul>
          <!-- <li>
              <a href="javascript:void();" [routerLink]="isLogin() ? ['/dashboard'] : ['/home']" routerLinkActive="sportsMenus_active">
                <img alt="home" src="assets/img/trophy.svg" class="img-fluid">
                home
              </a>
          </li> -->
          <li>
              <a href="javascript:void();" routerLink="/inplay" routerLinkActive="sportsMenus_active">
                <img alt="in-play" src="https://speedcdn.io/assets/radheexch-client/icons/in-play-icon.svg" class="img-fluid">
                in-play
              </a>
          </li>
          <!-- <li>
              <a class="blink-soft">
                <img class="img-fluid" src="assets/img/aviator-icon.svg">
                  aviator
              </a>
          </li> -->
          <li *ngFor="let item of menuItems;">
            <!-- all available sports and races and others -->
            <!-- *ngIf="(events.sports.includes(item.id) || events.races.includes(item.id))" -->
            <a href="javascript:void();" [ngClass]="{ 'awesomemobile': events.binary.includes(item.id)}" *ngIf="!events.casino.includes(item.id) && item.id != '883'" (click)="openLogin('')" [routerLink]="['/sports', item?.id]" routerLinkActive="sportsMenus_active">
              <img alt="" src="https://speedcdn.io/assets/radheexch-client/icons/{{item.id}}.png" class="img-fluid">
              <span id="tagLive" class="tag-live" *ngIf="item.in_play_count > 0"><strong></strong>{{item.in_play_count}}</span>
              <span *ngIf="events.races.includes(item.id)">{{item?.name.slice(0, item?.name.indexOf(' '))}}</span>
              <span *ngIf="!events.races.includes(item.id)">{{item?.name}}</span>
            </a>
            <a *ngIf="item.id == '883'" href="javascript:void();" class="awesomemobile" (click)="confirmBox(item)"  routerLinkActive="sportsMenus_active">
              <img alt="" src="https://speedcdn.io/assets/radheexch-client/icons/aviator-icon.svg" class="img-fluid">
              <span>{{item?.name}}</span>
            </a>
            <!-- all available casino -->
            <a href="javascript:void();" [ngClass]="{ 'awesomemobile': events.casino.includes(item.id) }" *ngIf="events.casino.includes(item.id)" [routerLink]="['/casino', item?.id]" routerLinkActive="sportsMenus_active">
              <img alt="" src="https://speedcdn.io/assets/radheexch-client/icons/{{item.id}}.svg" class="img-fluid">
              {{item?.name}}
            </a>
          </li>
          <li>
              <a href="javascript:void(0)" (click)="redirectCasinoWithTabSelection(99995, 4)">
                <img alt="" src="https://speedcdn.io/assets/radheexch-client/icons/icon-ezugi.png" class="img-fluid">
                ezugi
              </a>
          </li>
          <li>
              <a href="javascript:void(0)" (click)="redirectCasinoWithTabSelection(99995, 1)">
                <img alt="" src="https://speedcdn.io/assets/radheexch-client/icons/icon-evolution.png" class="img-fluid">
                evolution
              </a>
          </li>
          <li>
              <a href="javascript:void(0)" (click)="redirectCasinoWithTabSelection(99995, 5)">
                <img alt="" src="https://speedcdn.io/assets/radheexch-client/icons/icon-bombay.png" class="img-fluid">
                bombay gaming
              </a>
          </li>
          <li>
              <a href="javascript:void(0)" (click)="redirectCasinoWithTabSelection(99995, 24)">
                <img alt="" src="https://speedcdn.io/assets/radheexch-client/icons/icon-betgames.png" class="img-fluid">
                betgames
              </a>
          </li>
          <!-- <li *ngIf="isLogin()">
              <a href="javascript:void();" routerLink="/event/multi-market" routerLinkActive="sportsMenus_active"><img alt="" src="assets/img/market.svg" class="img-fluid">multi
                  markets</a>
          </li> -->
          
          
          
      </ul>
  </div>

</div>
<!-- end Topbar -->

<div id="rightsidebar" class="right-sidenav" style="right: 0px; display: none;">
    <a href="javascript:void(0);" (click)="closeRightBar();" class="closebtn" >×</a>
    <span class="profilename"><i class="mdi mdi-account darkblue pr-2 cmenu" aria-hidden="true"></i>{{user.username}} - ({{fixedPostDecimal(user?.available_balance)}})</span>
    <div class="rightside-exposure">
        <div class="right-wallet-detail-group cmenu"  routerLink="/market-analysis">
            <dl class="wallet-detail-content mb-1 cmenu">
                <dt class="cmenu">Exposure</dt>
                <dd class="wallet-balance-num cmenu">
                    <span id="mainBalance" class="cmenu">
                      <span class="cmenu"[ngClass]="user?.expose >= 0 ? 'profit' : 'loss'">{{positiveVal(fixedPostDecimal(user?.expose))}}</span>
                    </span>
                </dd>
            </dl>
        </div>
        <div class="right-wallet-detail-group cmenu">
            <dl class="wallet-detail-content mb-1 cmenu">
                <dt class="cmenu">P&amp;L</dt>
                <dd class="wallet-balance-num cmenu">
                    <span id="mainBalance" class="cmenu">
                      <!-- <span style="color: green;">3509.72</span> -->
                      <span class="cmenu" [ngClass]="user.pl >= 0 ? 'profit' : 'loss'">{{user?.pl}}</span>
                    </span>
                </dd>
            </dl>
        </div>
    </div>
    <!-- <div class="rightside-exposure">
        <div class="right-wallet-detail-group cmenu cg-btn-new">
            <dl class="wallet-detail-content mb-1 cmenu">
                <dt class="cmenu cg-btn-f">CG Exposure</dt>
                <dd class="wallet-balance-num cmenu pb-0 mb-0">
                    <span id="mainBalance" class="cmenu"><span class="cmenu">0.00</span></span>
                </dd>
            </dl>
        </div>
        <div class="right-wallet-detail-group cmenu cg-btn-new">
            <dl class="wallet-detail-content mb-1 cmenu">
                <dt class="cmenu cg-btn-f">CG P&amp;L</dt>
                <dd class="wallet-balance-num cmenu pb-0 mb-0">
                    <span id="mainBalance" class="cmenu"><span class="cmenu">0.00</span></span>
                </dd>
            </dl>
        </div>
    </div> -->
    <ul id="account_pop" class="cmenu" style="display: block; z-index: 999;">
        <li>
            <a href="javascript:void();" routerLink="/reports/account-statement" (click)="closeRightBar();"><img alt="" src="https://speedcdn.io/assets/radheexch-client/icons/account-statement.svg" class="ball-images-tab" />Account Statement</a>
        </li>
        <!-- <li>
            <a><img alt="" src="https://images.staticcontent.io/casino/banner/images/Account-Statement.svg" class="ball-images-tab" /> CG Account Statement</a>
        </li> -->
        <li>
            <a href="javascript:void();" routerLink="/reports/profit-loss" (click)="closeRightBar();"><img alt="" src="https://speedcdn.io/assets/radheexch-client/icons/profit-loss-report.svg" class="ball-images-tab" /> Profit Loss Report</a>
        </li>
        <!-- <li>
            <a href="javascript:void();" (click)="closeRightBar();"><img alt="" src="https://images.staticcontent.io/casino/banner/images/bet-history.svg" class="ball-images-tab" /> Bet Histroy</a>
        </li> -->
        <!-- <li>
            <a><img alt="" src="https://images.staticcontent.io/casino/banner/images/bet-history.svg" class="ball-images-tab" />CG Bet Histroy</a>
        </li> -->
        <li>
            <a href="javascript:void();" routerLink="/reports/unsettled-bets" (click)="closeRightBar();"><img alt="" src="https://speedcdn.io/assets/radheexch-client/icons/unsettle-bet.svg" class="ball-images-tab" /> Unsettled Bet</a>
        </li>
        <!-- <li>
            <a><img alt="" src="https://images.staticcontent.io/casino/banner/images/unsettle-bet.svg" class="ball-images-tab" />CG Unsettled Bet</a>
        </li> -->
        <li>
            <a href="javascript:void();" routerLink="/stake-setting" (click)="closeRightBar();"><img alt="" src="https://speedcdn.io/assets/radheexch-client/icons/set-button-value.svg" class="ball-images-tab" /> Set Stake</a>
        </li>
        <li>
            <a href="javascript:void();" routerLink="/rules" (click)="closeRightBar();"><img alt="" src="https://speedcdn.io/assets/radheexch-client/icons/rules.svg" class="ball-images-tab" /> Rules</a>
        </li>
        <li>
            <a href="javascript:void();" routerLink="/change-password" (click)="closeRightBar();"><img alt="" src="https://speedcdn.io/assets/radheexch-client/icons/change-password.svg" class="ball-images-tab" /> Change Password</a>
        </li>
        <li *ngIf="isLogin()">
          <a href="javascript:void();" routerLink="/market-analysis" (click)="closeRightBar();"><img alt="" src="https://speedcdn.io/assets/radheexch-client/icons/unsettle-bet.svg" class="ball-images-tab">Market Analysis</a>
        </li>
        <li class="logout">
            <a id="logout" href="javascript:void();" (click)="logOut();"><img alt="" src="https://speedcdn.io/assets/radheexch-client/icons/log-out.svg" class="ball-images-tab" /> Logout</a>
        </li>
    </ul>
</div>
<!-- <div class="overlay" id="RightMenuoverlay" style="display: block;"></div> -->
{{(env.wpLinkShowPages.includes(router.url.split('/')[1])) && wpLink != ''}}
<!-- <a *ngIf="(env.wpLinkShowPages.includes(router.url.split('/')[1])) && wpLink != '' && !env.isMobile" class="whatsapp_link" [href]="wpLink" target="_blank"><img src="https://cdn-icons-png.flaticon.com/512/3670/3670051.png"></a>
<a *ngIf="(env.wpLinkShowPages.includes(router.url.split('/')[2])) && wpLink != '' && env.isMobile" class="whatsapp_link" [href]="wpLink" target="_blank"><img src="https://cdn-icons-png.flaticon.com/512/3670/3670051.png"></a> -->
<a class="whatsapp_link" *ngIf="(env.wpLinkShowPages.includes(router.url.split('/')[1])) && wpLink != ''" [href]="wpLink" target="_blank">
    <img src="https://speedcdn.io/assets/radheexch-client/icons/social_whatsapp.svg" class="img-fluid">
</a>

<div class="modal fade force-change-password-popup afterLoginModal" bsModal #afterLoginModal="bs-modal"
    [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="">
    <div class="modal-dialog bookModal app_version">
        <div class="modal-content">
            <div class="modal-body p-0">
                <button style="position: absolute;right: 13px;top: 1px;color: #fff;font-size: 21px;" type="button" class="close" data-bs-dismiss="modal" aria-label="Close"
                    (click)="afterLoginModal.hide()">
                    <span aria-hidden="true">&times;</span>
                </button>
                <a (click)="afterLoginModal.hide()">
                    <img style="width: 100%;" [src]="env.host.afterLoginNoticePath" >
                    <!-- <img style="width: 100%;" src="assets/img/popup.jpg"> -->
                </a>
            </div>
        </div>
    </div>
</div>

<!-- modal exposure -->
<!-- <div class="modal fade exposureModal" id="ExposurePopup" tabindex="-1" role="dialog"
aria-labelledby="ExposurePopupLabel" aria-hidden="true">
<div class="modal-dialog modal-lg">
    <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title mt-0">Unsetteled Bets</h5>
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
        </div>
        <div class="modal-body">
            <div class="table-responsive">
                <table class="table table-bordered table-sm">
                    <thead>
                        <tr>
                            <th>Competition</th>
                            <th>Event</th>
                            <th>Market</th>
                            <th>Runner</th>
                            <th>Side</th>
                            <th>Line</th>
                            <th>Rate</th>
                            <th>Amount</th>
                            <th>PP</th>
                            <th>PL</th>
                            <th>Status</th>
                            <th>Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td colspan="15" align="center">No Data Found.</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="modal-footer">
            <div class="row w-100">
                <div class="col-12 col-sm-12 col-md-6"><span class="frleft">Showing 0 of 0 entries</span>
                </div>
                <div class="col-12 col-sm-12 col-md-6">
                    <div class="btn-group mr-2">
                        <button type="button" class="btn btn-blue" disabled="">Prev</button><button
                            class="btn btn-blue">1</button>
                        <button type="button" class="btn btn-blue" id="NextPage" name="next"
                            disabled="">Next</button>
                    </div>
                    <button type="button" class="btn btn-outline-danger"
                        data-dismiss="modal">Cancel</button>
                </div>
            </div>
        </div>

    </div>
</div>
</div> -->
<!-- modal exposure -->